document.addEventListener("DOMContentLoaded", function () {
  let currentCart = null;

  // Initialize cart
  async function initializeCart() {
    try {
      const res = await fetch("/cart.js");
      currentCart = await res.json();
      syncCheckboxesWithCart();
      renderCartItems(); // initial render
    } catch (e) {
      console.error("Cart init failed:", e);
    }
  }

  // Sync checkbox states
  function syncCheckboxesWithCart() {
    if (!currentCart) return;
    document.querySelectorAll(".ua-addon-checkbox").forEach((checkbox) => {
      const variantId = parseInt(checkbox.dataset.addonVariant);
      const item = currentCart.items.find((i) => i.variant_id === variantId);
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      const title = checkbox.dataset.addonTitle;
      const price = checkbox.dataset.addonPrice;

      if (item) {
        checkbox.checked = true;
        checkbox.dataset.lineKey = item.key;
        if (label) label.textContent = `${title} — Added ✅`;
      } else {
        checkbox.checked = false;
        checkbox.dataset.lineKey = "";
        if (label) label.textContent = `${title} — Rs. ${parseInt(price / 100)}`;
      }
    });
  }

  // Update cart UI (count, total, and items)
  async function updateCartUI() {
    try {
      const res = await fetch("/cart.js");
      currentCart = await res.json();

      // Update count bubbles
      document.querySelectorAll('.cart-count, .js-cart-count, [data-cart-count], .header__cart-count').forEach(el => {
        el.textContent = currentCart.item_count;
        el.style.display = currentCart.item_count > 0 ? 'inline' : 'none';
      });

      // Update total price
      const formattedPrice = Shopify.formatMoney(currentCart.total_price, window.money_format || '{{amount}}');
      document.querySelectorAll('.cart-total, .js-cart-total, [data-cart-total]').forEach(el => {
        el.textContent = formattedPrice;
      });

      // Render cart items with thumbnails, name, price, quantity
      renderCartItems();

      // Dispatch Shopify events
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: currentCart}}));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: currentCart}}));
    } catch (err) {
      console.error("Cart UI update failed:", err);
    }
  }

  // Render cart items in a container (you can choose any cart drawer wrapper)
  function renderCartItems() {
    const container = document.querySelector('.custom-cart-items'); // create this in your theme
    if (!container) return;

    container.innerHTML = ''; // clear
    currentCart.items.forEach(item => {
      const el = document.createElement('div');
      el.className = 'custom-cart-item';
      el.style.display = 'flex';
      el.style.gap = '10px';
      el.style.marginBottom = '10px';
      el.innerHTML = `
        <img src="${item.image}" alt="${item.title}" style="width:50px;height:50px;object-fit:cover;border-radius:6px;">
        <div style="flex:1">
          <div class="cart-item-title">${item.product_title}</div>
          <div class="cart-item-variant">${item.title}</div>
          <div class="cart-item-price">${Shopify.formatMoney(item.price, window.money_format || '{{amount}}')}</div>
          <div class="cart-item-qty">Qty: ${item.quantity}</div>
        </div>
      `;
      container.appendChild(el);
    });
  }

  // Handle addon checkbox change
  document.querySelectorAll(".ua-addon-checkbox").forEach((checkbox) => {
    checkbox.addEventListener("change", async function () {
      const variantId = parseInt(this.dataset.addonVariant);
      const title = this.dataset.addonTitle;
      const price = this.dataset.addonPrice;
      const label = document.querySelector(`label[for="${this.id}"]`);
      const originalState = this.checked;
      this.disabled = true;

      if (label) label.textContent = `${title} — ${this.checked ? 'Adding...' : 'Removing...'}`;

      try {
        if (this.checked) {
          // Add to cart
          await fetch("/cart/add.js", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
          });
        } else {
          // Remove addon
          const lineKey = this.dataset.lineKey;
          if (lineKey) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: {"Content-Type": "application/json"},
              body: JSON.stringify({id: lineKey, quantity: 0})
            });
          } else {
            const res = await fetch("/cart.js");
            const cart = await res.json();
            const item = cart.items.find(i => i.variant_id === variantId);
            if (item) {
              await fetch("/cart/change.js", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({id: item.key, quantity: 0})
              });
            }
          }
        }

        await updateCartUI();
        syncCheckboxesWithCart();
      } catch (err) {
        console.error("Addon error:", err);
        this.checked = !originalState;
        syncCheckboxesWithCart();
        if (label) label.textContent = `${title} — Error!`;
      } finally {
        this.disabled = false;
      }
    });
  });

  // Initialize
  initializeCart();
});
